import _defineProperty from "C:\\Users\\Kristaps\\projects\\proj261\\site\\node_modules\\@babel\\runtime\\helpers\\esm\\defineProperty.js";
import _slicedToArray from "C:\\Users\\Kristaps\\projects\\proj261\\site\\node_modules\\@babel\\runtime\\helpers\\esm\\slicedToArray.js";
var _excluded = ["value", "use12HourClock", "padValues", "emptyCharacter", "precision", "noClearButton", "hoursAddon", "minutesAddon", "secondsAddon", "millisecondsAddon", "className", "disabled", "readOnly", "datePart", "onChange", "onBlur", "onFocus"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import classNames from 'classnames';
import qsa from 'dom-helpers/querySelectorAll';
import React, { useCallback, useRef, useState } from 'react';
import { useUncontrolled } from 'uncontrollable';
import Button from './Button';
import DateTimePartInput from './DateTimePartInput';
import { times } from './Icon';
import Widget from './Widget';
import dates from './dates';
import useFocusManager from './useFocusManager';

var selectTextRange = function selectTextRange(el) {
  if (el instanceof HTMLInputElement) return el.select();
  var range = document.createRange();
  range.selectNodeContents(el);
  var selection = window.getSelection();

  if (selection) {
    selection.removeAllRanges();
    selection.addRange(range);
  }
}; // prettier-ignore


var isEmptyValue = function isEmptyValue(p, precision) {
  return p.hours == null && p.minutes == null && (precision != 'seconds' && precision !== 'milliseconds' || p.seconds == null) && (precision !== 'milliseconds' || p.milliseconds == null);
}; // prettier-ignore


var isPartialValue = function isPartialValue(p, precision) {
  return p.hours == null || p.minutes == null || (precision === 'seconds' || precision === 'milliseconds') && p.seconds == null || precision === 'milliseconds' && p.milliseconds == null;
};

var getValueParts = function getValueParts(value, use12HourClock) {
  var hours, minutes, seconds, milliseconds;
  var meridiem = 'AM';

  if (value) {
    hours = value.getHours();

    if (use12HourClock) {
      meridiem = hours < 12 ? 'AM' : 'PM';
      hours = hours % 12 || 12;
    }

    minutes = value.getMinutes();
    seconds = value.getSeconds();
    milliseconds = value.getMilliseconds();
  }

  return {
    hours: hours,
    minutes: minutes,
    seconds: seconds,
    milliseconds: milliseconds,
    meridiem: meridiem
  };
};

var TEST_VALID = {
  hours: /^([1]?[0-9]|2[0-3])$/,
  hours12: /^(1[0-2]|0?[1-9])$/,
  minutes: /^([0-5]?\d)$/,
  seconds: /^([0-5]?\d)$/,
  milliseconds: /^(\d{1,3})$/
};
var TEST_COMPLETE = {
  hours: /^([3-9]|\d{2})$/,
  hours12: /^(\d{2}|[2-9])$/,
  minutes: /^(d{2}|[6-9])$/,
  seconds: /^(d{2}|[6-9])$/,
  milliseconds: /^(\d{3})$/
};

function testPart(value, part, use12HourClock, tests) {
  var key = part === 'hours' && use12HourClock ? 'hours12' : part;
  return tests[key].test(value);
}

var isValid = function isValid(value, part, use12HourClock) {
  return testPart(value, part, use12HourClock, TEST_VALID);
};

var isComplete = function isComplete(value, part, use12HourClock) {
  return testPart(value, part, use12HourClock, TEST_COMPLETE);
};

var defaultProps = {
  hoursAddon: ':',
  padValues: true,
  precision: 'minutes',
  emptyCharacter: '-'
}; // let count = 0

function useTimePartState(value, use12HourClock) {
  var _useState = useState(function () {
    return {
      value: value,
      use12HourClock: use12HourClock,
      timeParts: getValueParts(value, use12HourClock)
    };
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var setTimeParts = useCallback(function (timeParts) {
    return setState(function (s) {
      return Object.assign({}, s, {
        timeParts: timeParts
      });
    });
  }, [setState]);

  if (state.value !== value || state.use12HourClock !== use12HourClock) {
    // count++
    // if (count < 100)
    setState({
      value: value,
      use12HourClock: use12HourClock,
      timeParts: getValueParts(value, use12HourClock)
    });
  }

  return [state.timeParts, setTimeParts];
}

function TimeInput(uncontrolledProps) {
  var _useUncontrolled = useUncontrolled(uncontrolledProps, {
    value: 'onChange'
  }),
      value = _useUncontrolled.value,
      use12HourClock = _useUncontrolled.use12HourClock,
      pad = _useUncontrolled.padValues,
      emptyCharacter = _useUncontrolled.emptyCharacter,
      precision = _useUncontrolled.precision,
      noClearButton = _useUncontrolled.noClearButton,
      hoursAddon = _useUncontrolled.hoursAddon,
      minutesAddon = _useUncontrolled.minutesAddon,
      secondsAddon = _useUncontrolled.secondsAddon,
      millisecondsAddon = _useUncontrolled.millisecondsAddon,
      className = _useUncontrolled.className,
      disabled = _useUncontrolled.disabled,
      readOnly = _useUncontrolled.readOnly,
      datePart = _useUncontrolled.datePart,
      onChange = _useUncontrolled.onChange,
      onBlur = _useUncontrolled.onBlur,
      onFocus = _useUncontrolled.onFocus,
      props = _objectWithoutPropertiesLoose(_useUncontrolled, _excluded);

  var minsAddon = minutesAddon !== undefined ? minutesAddon : precision === 'seconds' || precision === 'milliseconds' ? ':' : '';
  var secsAddon = secondsAddon !== undefined ? secondsAddon : precision === 'milliseconds' ? ':' : '';
  var ref = useRef(null);
  var hourRef = useRef(null);

  var _useFocusManager = useFocusManager(ref, {
    disabled: disabled,
    onBlur: onBlur,
    onFocus: onFocus
  }, {
    didHandle: function didHandle(focused, e) {
      var _hourRef$current;

      if (!focused) return;
      if (!e.target.dataset.focusable) (_hourRef$current = hourRef.current) == null ? void 0 : _hourRef$current.focus();else select(e.target);
    }
  }),
      _useFocusManager2 = _slicedToArray(_useFocusManager, 2),
      focusEvents = _useFocusManager2[0],
      focused = _useFocusManager2[1];

  var _useTimePartState = useTimePartState(value != null ? value : null, use12HourClock != null ? use12HourClock : false),
      _useTimePartState2 = _slicedToArray(_useTimePartState, 2),
      timeParts = _useTimePartState2[0],
      setTimeParts = _useTimePartState2[1];

  function getDatePart() {
    return dates.startOf(datePart || new Date(), 'day');
  }

  var getMin = function getMin(part) {
    return part === 'hours' ? 1 : 0;
  };

  var getMax = function getMax(part) {
    if (part === 'hours') return use12HourClock ? 12 : 23;
    if (part === 'milliseconds') return 999;
    return 59;
  };

  function select() {
    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.activeElement;
    window.Promise.resolve().then(function () {
      if (focused) selectTextRange(target);
    });
  }
  /**
   * Handlers
   */


  var handleClear = function handleClear() {
    var _hourRef$current2;

    (_hourRef$current2 = hourRef.current) == null ? void 0 : _hourRef$current2.focus();
    if (value) onChange(null);else setTimeParts(getValueParts(null));
  };

  var handleChange = function handleChange(part, event) {
    var currentValue = timeParts[part];
    var target = event.target;
    var rawValue = target.value;
    var strValue = "".concat(currentValue || '').concat(rawValue);
    var numValue = +strValue;

    if (isNaN(numValue) || strValue && !isValid(strValue, part, use12HourClock != null ? use12HourClock : false)) {
      // the combined value is now past the max or invalid so try the single
      // digit and "start over" filling the value
      if (isValid(rawValue, part, use12HourClock != null ? use12HourClock : false) && !isNaN(+rawValue)) {
        // change the effective current value
        strValue = rawValue;
        numValue = +rawValue;
      } else {
        return event.preventDefault();
      }
    }

    var nextValue = target.value ? numValue : null;
    notifyChange(_defineProperty({}, part, nextValue));

    if (nextValue != null && isComplete(strValue, part, use12HourClock != null ? use12HourClock : false)) {
      focusNext(event.currentTarget, +1);
    } else {
      select(target);
    }
  };

  var handleSelect = function handleSelect(_ref) {
    var target = _ref.target;
    select(target);
  };

  var handleKeyDown = function handleKeyDown(part, event) {
    var key = event.key;
    var input = event.currentTarget;
    var start = input.selectionStart,
        end = input.selectionEnd;
    var isRTL = getComputedStyle(input).getPropertyValue('direction') === 'rtl';
    var isMeridiem = part === 'meridiem';
    var isNext = key === (isRTL ? 'ArrowLeft' : 'ArrowRight');
    var isPrev = key === (isRTL ? 'ArrowRight' : 'ArrowLeft');

    if (key === 'ArrowUp') {
      event.preventDefault();
      increment(part, 1);
    }

    if (key === 'ArrowDown') {
      event.preventDefault();
      increment(part, -1);
    }

    if (isPrev && (isMeridiem || start - 1 < 0)) {
      event.preventDefault();
      focusNext(input, -1);
    }

    if (isNext && (isMeridiem || input.value.length <= end + 1)) {
      event.preventDefault();
      focusNext(input, +1);
    }

    if (readOnly && key !== 'Tab') {
      event.preventDefault();
    }

    if (isMeridiem) {
      if (key === 'a' || key === 'A') notifyChange({
        meridiem: 'AM'
      });
      if (key === 'p' || key === 'P') notifyChange({
        meridiem: 'PM'
      });
    }
  };

  var increment = function increment(part, inc) {
    var nextPart = timeParts[part];

    if (part === 'meridiem') {
      nextPart = nextPart === 'AM' ? 'PM' : 'AM';
    } else {
      nextPart = (nextPart || 0) + inc;
      if (!isValid(String(nextPart), part, use12HourClock != null ? use12HourClock : false)) return;
    }

    notifyChange(_defineProperty({}, part, nextPart));
    select();
  };

  function notifyChange(updates) {
    var nextTimeParts = Object.assign({}, timeParts, updates);

    if (value && isEmptyValue(nextTimeParts, precision)) {
      return onChange(null);
    }

    if (isPartialValue(nextTimeParts, precision)) return setTimeParts(nextTimeParts);
    var hours = nextTimeParts.hours,
        minutes = nextTimeParts.minutes,
        seconds = nextTimeParts.seconds,
        milliseconds = nextTimeParts.milliseconds,
        meridiem = nextTimeParts.meridiem;
    var nextDate = new Date(value || getDatePart());

    if (use12HourClock) {
      if (hours === 12) hours = 0;
      hours += meridiem === 'PM' ? 12 : 0;
    }

    nextDate.setHours(hours);
    nextDate.setMinutes(minutes);
    if (seconds != null) nextDate.setSeconds(seconds);
    if (milliseconds != null) nextDate.setMilliseconds(milliseconds);
    onChange(nextDate, {
      lastValue: value,
      timeParts: timeParts
    });
  }

  function focusNext(input, delta) {
    var nodes = qsa(ref.current, '* [data-focusable]');
    var next = nodes[nodes.indexOf(input) + delta];
    next == null ? void 0 : next.focus();
    select(next);
  }

  var hours = timeParts.hours,
      minutes = timeParts.minutes,
      seconds = timeParts.seconds,
      milliseconds = timeParts.milliseconds,
      meridiem = timeParts.meridiem;
  var showClear = !isEmptyValue(timeParts, precision);
  return /*#__PURE__*/React.createElement(Widget, _extends({}, props, {
    role: "group",
    ref: ref
  }, focusEvents, {
    focused: focused,
    disabled: disabled,
    readOnly: readOnly,
    className: classNames(className, 'rw-time-input rw-widget-input')
  }), /*#__PURE__*/React.createElement(DateTimePartInput, {
    size: 2,
    pad: pad ? 2 : undefined,
    value: hours,
    disabled: disabled,
    readOnly: readOnly,
    "aria-label": "hours",
    min: getMin('hours'),
    max: getMax('hours'),
    ref: hourRef,
    emptyChar: emptyCharacter,
    onSelect: handleSelect,
    onChange: function onChange(e) {
      return handleChange('hours', e);
    },
    onKeyDown: function onKeyDown(e) {
      return handleKeyDown('hours', e);
    }
  }), hoursAddon && /*#__PURE__*/React.createElement("span", null, hoursAddon), /*#__PURE__*/React.createElement(DateTimePartInput, {
    size: 2,
    pad: pad ? 2 : undefined,
    value: minutes,
    disabled: disabled,
    readOnly: readOnly,
    "aria-label": "minutes",
    min: getMin('minutes'),
    max: getMax('minutes'),
    emptyChar: emptyCharacter,
    onSelect: handleSelect,
    onChange: function onChange(e) {
      return handleChange('minutes', e);
    },
    onKeyDown: function onKeyDown(e) {
      return handleKeyDown('minutes', e);
    }
  }), minsAddon && /*#__PURE__*/React.createElement("span", null, minsAddon), (precision === 'seconds' || precision === 'milliseconds') && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DateTimePartInput, {
    size: 2,
    pad: pad ? 2 : undefined,
    value: seconds,
    disabled: disabled,
    readOnly: readOnly,
    "aria-label": "seconds",
    min: getMin('seconds'),
    max: getMax('seconds'),
    emptyChar: emptyCharacter,
    onSelect: handleSelect,
    onChange: function onChange(e) {
      return handleChange('seconds', e);
    },
    onKeyDown: function onKeyDown(e) {
      return handleKeyDown('seconds', e);
    }
  }), secsAddon && /*#__PURE__*/React.createElement("span", null, secsAddon)), precision === 'milliseconds' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DateTimePartInput, {
    size: 3,
    pad: pad ? 3 : undefined,
    value: milliseconds,
    disabled: disabled,
    readOnly: readOnly,
    "aria-label": "milliseconds",
    min: getMin('milliseconds'),
    max: getMax('milliseconds'),
    emptyChar: emptyCharacter,
    onSelect: handleSelect,
    onChange: function onChange(e) {
      return handleChange('milliseconds', e);
    },
    onKeyDown: function onKeyDown(e) {
      return handleKeyDown('milliseconds', e);
    }
  }), millisecondsAddon && /*#__PURE__*/React.createElement("span", null, millisecondsAddon)), use12HourClock && /*#__PURE__*/React.createElement("div", {
    role: "listbox",
    "aria-label": "AM/PM",
    "aria-disabled": disabled,
    "aria-readonly": readOnly,
    className: "rw-time-part-meridiem"
  }, /*#__PURE__*/React.createElement("div", {
    "data-focusable": true,
    role: "option",
    "aria-atomic": true,
    "aria-selected": true,
    "aria-setsize": 2,
    "aria-live": "assertive",
    "aria-disabled": disabled,
    "aria-readonly": readOnly,
    "aria-posinset": meridiem === 'AM' ? 1 : 2,
    tabIndex: !disabled ? 0 : void 0,
    onFocus: handleSelect,
    onSelect: handleSelect,
    onKeyDown: function onKeyDown(e) {
      return handleKeyDown('meridiem', e);
    }
  }, /*#__PURE__*/React.createElement("abbr", null, meridiem))), !noClearButton && /*#__PURE__*/React.createElement(Button, {
    label: 'clear input',
    onClick: handleClear,
    disabled: disabled || readOnly,
    className: classNames('rw-time-input-clear', showClear && 'rw-show')
  }, times));
}

TimeInput.defaultProps = defaultProps;
export default TimeInput;